
import { useNavigate } from 'react-router-dom';
import { UserPlus, LogIn } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface RegistrationRequiredModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  anonymousLimit: number;
}

const RegistrationRequiredModal = ({ open, onOpenChange, anonymousLimit }: RegistrationRequiredModalProps) => {
  const navigate = useNavigate();

  const handleNavigateToAuth = () => {
    onOpenChange(false);
    navigate('/auth');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl">
            ¡Crea una cuenta gratuita!
          </DialogTitle>
          <DialogDescription className="text-base pt-2">
            Has usado tus {anonymousLimit} compresiones gratuitas sin cuenta.
            Regístrate gratis para obtener <strong>10 compresiones diarias</strong> y acceder a tu historial.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 pt-4">
          <Button onClick={handleNavigateToAuth} className="flex-1 gap-2">
            <UserPlus className="w-4 h-4" />
            Crear cuenta
          </Button>
          <Button onClick={handleNavigateToAuth} variant="outline" className="flex-1 gap-2">
            <LogIn className="w-4 h-4" />
            Ya tengo cuenta
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RegistrationRequiredModal;
